import { WizardWrapper } from './WizardWrapper';
import { useWizardContext } from './hooks/useWizardContext';
import { WizardValidationMessages } from './WizardValidationMessages';
import { WizardNavigation } from './WizardNavigation';
import { useMemo } from 'react';
import { useWizardState } from './hooks/useWizardState';
import { useWizardNavigation } from './hooks/useWizardNavigation';
import { Skeleton } from '@chakra-ui/react';

export function Wizard() {
    const { config } = useWizardContext();
    const { currentStep, percentComplete, handleReset, isSubmitting, isValidating } = useWizardState();
    const { canGoBack, handleBack, isLastStep } = useWizardNavigation();

    if (!currentStep || !config) {
        throw new Error('Invalid wizard state: currentStep or config is not defined');
    }

    const StepComponent = useMemo(() => {
        return config.steps[currentStep.id]?.component;
    }, [config, currentStep]);

    if (!StepComponent) {
        throw new Error(`Component for step "${currentStep.id}" not found in the wizard config`);
    }

    return (
        <WizardWrapper
            percent={percentComplete}
            showDetailsInWrapper={config.showDetailsInWrapper}
            title={config.title}
            subTitle={currentStep?.title}
            description={currentStep?.description}
            helperText={currentStep?.helperText}
        >
            <WizardValidationMessages />
            {isSubmitting ? <Skeleton height="40px" /> : <StepComponent />}
            <WizardNavigation
                canGoBack={canGoBack}
                handleReset={handleReset}
                isSubmitting={isSubmitting || isValidating}
                currentStep={currentStep}
                handleBack={handleBack}
                isLastStep={isLastStep}
            />
        </WizardWrapper>
    );
}
